import { ClientWithAuth } from 'client/services/service';
const serviceUrlSuffix = '/logging-service';

const noop = () => {};

const LOG_LEVELS = Object.freeze({
    DEBUG: 'DEBUG',
    INFO: 'INFO',
    WARN: 'WARN',
    ERROR: 'ERROR'
});

const log = (title, message, logLevel = LOG_LEVELS.INFO) => {
    if (!message) {
        // eslint-disable-next-line no-console
        console.warn('Log message not provided - using title');
        // message is required
        message = title;
    }
    if (typeof message !== 'string') {
        // message must be a string
        message = JSON.stringify(message);
    }

    if (!LOG_LEVELS[logLevel]) {
        // eslint-disable-next-line no-console
        console.warn(`Unknown log level ${logLevel} - falling back to ${LOG_LEVELS.INFO}`);
        logLevel = LOG_LEVELS.INFO;
    }

    // Minimum payload here. Other required metadata is set by the api
    const payload = {
        eventDetails: {
            title,
            message,
            logLevel
        }
    };

    const logPromise = ClientWithAuth.post(serviceUrlSuffix, JSON.stringify(payload)).catch(noop);

    // Wrap the promise so that calling code doesn't try to use or wait for it unless they really need to
    // e.g. if you are doing log('something'); reloadPage(); then await the log first
    // like this: await log('something').promise; reloadPage();
    return {
        promise: logPromise
    };
};

const logWithPrefix = (prefix) => {
    return (title, ...args) => log(`[${prefix}] ${title}`, ...args);
};

export default log;

export {
    logWithPrefix,
    log,
    LOG_LEVELS
};
